import {useMemo} from 'react';

import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {confirmationBookedAppointment} from 'presentation/modules/myAppointments/utils/confirmationBookedAppointment';
import {useGetHomeQuery} from 'presentation/pages/private/home/query/useGetHomeQuery';

export const useBookedAppointmentConfirmation = (id?: string) => {
	const {
		data: appointmentsList,
		refetch,
		isError: appointmentsListError,
		isLoading: appointmentsListLoading,
	} = useGetHomeQuery();
	const {isEnabled: isAdvanceDiagnosticsExamsJourneyEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_ADVANCE_DIAGNOSTICS_EXAMS_JOURNEY,
	);

	const appointmentsListHasValue = !!appointmentsList?.appointments;

	const confirmedBookAppointment = useMemo(() => {
		if (!appointmentsList?.appointments || !id) return null;

		return confirmationBookedAppointment({
			bookingNumber: id,
			appointments: appointmentsList.appointments,
			isAdvanceDiagnosticsExamsJourneyEnabled,
		});
	}, [id, appointmentsList?.appointments, isAdvanceDiagnosticsExamsJourneyEnabled]);

	return {
		confirmedBookAppointment,
		appointmentsListHasValue,
		appointmentsListError,
		appointmentsListLoading,
		refresh: refetch,
	};
};
